var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCreditCard = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  "aria-hidden": "true",
  focusable: "false",
  viewBox: "0 0 24 24",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "svg-credit-card__a",
  d: "M18.826.435a2.239 2.239 0 0 1 2.24 2.239v12.174a2.239 2.239 0 0 1-2.24 2.239H3.174a2.239 2.239 0 0 1-2.24-2.24V2.675a2.239 2.239 0 0 1 2.24-2.24Zm1.239 7.956H1.935v6.457c0 .642.487 1.17 1.112 1.233l.127.006h15.652a1.24 1.24 0 0 0 1.24-1.24l-.001-6.456ZM9.76 11.739v1H4.413v-1h5.348Zm7.826 0v1h-1.87v-1h1.87Zm2.478-6.826H1.935V7.39h18.13V4.913Zm-1.239-3.478H3.174c-.685 0-1.24.554-1.24 1.239v1.239h18.13l.001-1.24c0-.641-.487-1.168-1.112-1.232l-.127-.006Z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(1 3)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "svg-credit-card__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#svg-credit-card__a"
})), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#svg-credit-card__a",
  fill: "#7F7F7F",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("g", {
  mask: "url(#svg-credit-card__b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M23-3H-1v24h24z"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCreditCard);
export default ForwardRef;